module.exports = __webpack_public_path__ + "static/radarLogo-dd6249e8f4588405f796e3ec5ecf6d0c.svg";